module.exports = __webpack_public_path__ + "img/logo-10life-trending.04f52d1.png";